import React from 'react';
import { CheckCircle2, BookOpen, Layers, Sparkles, MessageCircle, TrendingUp, Bot } from 'lucide-react';
export function Modules() {
  const modules = [{
    icon: BookOpen,
    title: 'MÓDULO 1',
    subtitle: 'Clases Listas para Usar',
    items: ['50+ clases completas (A1–A2)', 'Objetivo, desarrollo y cierre', 'Actividades, ejercicios y tareas', 'Progresión por nivel', 'Versión online y presencial'],
    result: 'Llegás a la clase sin pensar qué dar'
  }, {
    icon: Layers,
    title: 'MÓDULO 2',
    subtitle: 'Sistema Anti-Improvisación',
    items: ['Estructura de clase reutilizable', 'Cómo preparar clases en 15 minutos', 'Framework simple y replicable'],
    result: 'Independencia total como profesor'
  }, {
    icon: Sparkles,
    title: 'MÓDULO 3',
    subtitle: 'Banco de Actividades Dinámicas',
    items: ['+100 actividades listas', 'Juegos y dinámicas', 'Rompe hielo', 'Actividades sin material'],
    result: 'Nunca más clases aburridas'
  }, {
    icon: MessageCircle,
    title: 'MÓDULO 4',
    subtitle: 'Conversación Lista',
    items: ['+100 preguntas por nivel', 'Temas listos', 'Sistema para hacer hablar al alumno'],
    result: 'Clases dinámicas desde el minuto 1'
  }, {
    icon: TrendingUp,
    title: 'MÓDULO 5',
    subtitle: 'Conseguir y Retener Alumnos',
    items: ['Cómo conseguir alumnos', 'Cómo evitar abandono', 'Cómo diferenciarte'],
    result: 'Convertís tu enseñanza en ingresos'
  }, {
    icon: Bot,
    title: 'MÓDULO 6',
    subtitle: 'IA para Clases',
    items: ['Prompts listos', 'Crear clases en minutos', 'Generar ejercicios automáticamente'],
    result: 'Ahorrás horas cada semana'
  }];
  return <section className="py-12 md:py-20 bg-white" data-id="element-174">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-175">
        <div className="text-center mb-10 md:mb-14" data-id="element-176">
          <p className="text-xs md:text-sm font-bold tracking-widest text-emerald-600 uppercase mb-2" data-id="element-177">
            EL SISTEMA COMPLETO
          </p>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-slate-900" data-id="element-178">
            ¿Qué incluye ITALIANO PRO KIT?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-179">
          {modules.map((mod, idx) => <div key={idx} className="group bg-white rounded-xl md:rounded-2xl border border-slate-200 overflow-hidden flex flex-col h-full hover:shadow-xl hover:border-emerald-300 transition-all duration-300" data-id="element-180">
              <div className="bg-slate-900 p-4 md:p-5 relative overflow-hidden" data-id="element-181">
                <div className="absolute top-0 right-0 h-full w-1 flex flex-col" data-id="element-182">
                  <div className="flex-1 bg-[#008C45]" data-id="element-183" />
                  <div className="flex-1 bg-white" data-id="element-184" />
                  <div className="flex-1 bg-[#CD212A]" data-id="element-185" />
                </div>
                <div className="flex items-center gap-3" data-id="element-186">
                  <div className="w-9 h-9 md:w-10 md:h-10 bg-emerald-500/20 text-emerald-300 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-187">
                    <mod.icon className="w-5 h-5" data-id="element-188" />
                  </div>
                  <div data-id="element-189">
                    <p className="text-[10px] md:text-xs font-bold text-emerald-400 tracking-wider" data-id="element-190">
                      {mod.title}
                    </p>
                    <h4 className="text-sm md:text-base font-bold text-white leading-tight" data-id="element-191">
                      {mod.subtitle}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-6 flex-grow flex flex-col" data-id="element-192">
                <ul className="space-y-2 md:space-y-2.5 mb-4 md:mb-6 flex-grow" data-id="element-193">
                  {mod.items.map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-194">
                      <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-195" />
                      <span className="text-sm md:text-base text-slate-700" data-id="element-196">
                        {item}
                      </span>
                    </li>)}
                </ul>
                <div className="bg-emerald-50 rounded-lg md:rounded-xl p-3 md:p-4 border border-emerald-100 mt-auto" data-id="element-197">
                  <p className="text-emerald-800 font-semibold text-xs md:text-sm" data-id="element-198">
                    <span className="font-bold" data-id="element-199">Resultado:</span> {mod.result}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}